module.exports = __webpack_public_path__ + "static/media/GMP Good Manufacturing Practice certified logo vector-07.dc17fa06.jpg";